/* __next_internal_client_entry_do_not_use__ useProductTileViewImpression auto */ import { usePairedIntersectionObserver } from "@faire/retailer-visitor-shared/hooks/ProductTileImpression/__internal__/ProductTileViewImpressionContext";
import { useUnmountProductTileContext } from "@faire/retailer-visitor-shared/hooks/ProductTileImpression/__internal__/UnmountProductTileContext";
import { useEffect } from "react";
export var useProductTileViewImpression = function(param) {
    var _param_productToken = param.productToken, productToken = _param_productToken === void 0 ? "" : _param_productToken, promotedBy = param.promotedBy, _param_impressionId = param.impressionId, impressionId = _param_impressionId === void 0 ? "" : _param_impressionId, _param_turnOffTracking = param.turnOffTracking, turnOffTracking = _param_turnOffTracking === void 0 ? true : _param_turnOffTracking;
    var isTrackingProductTileEnabled = !turnOffTracking;
    var handleIntersectionObserverCallbackRef = usePairedIntersectionObserver();
    var onUnmount = useUnmountProductTileContext().onUnmount;
    var _promotedBy_join;
    var promotedByString = (_promotedBy_join = promotedBy === null || promotedBy === void 0 ? void 0 : promotedBy.join(",")) !== null && _promotedBy_join !== void 0 ? _promotedBy_join : "";
    useEffect(function() {
        return function() {
            if (isTrackingProductTileEnabled) {
                onUnmount(productToken, impressionId);
            }
        };
    }, [
        isTrackingProductTileEnabled,
        productToken,
        impressionId,
        onUnmount
    ]);
    if (isTrackingProductTileEnabled) {
        return {
            ref: handleIntersectionObserverCallbackRef,
            "data-product-impression-id": impressionId,
            "data-product-token": productToken,
            "data-product-promoted-by": promotedByString
        };
    }
    return {
        ref: undefined,
        "data-product-impression-id": "",
        "data-product-promoted-by": "",
        "data-product-token": ""
    };
};
